import './DeleteModal.scss';

import exit from '../../assets/images/icons/exit.svg';

function DeleteModal({ handleDelete, setDeleteModal, modToDelete, tableName }) {

    return (
        <section className='delete-modal'>
            <article className='delete-modal__modal'>
                <div className='delete-modal__modal-top'>
                    <img onClick={() => setDeleteModal(false)} src={exit} alt='white x'></img>
                </div>
                <div className='delete-modal__modal-content'>
                    <p className='delete-modal__modal-content-text'>
                        ARE YOU SURE YOU WANT TO DELETE
                    </p>
                    <p className='delete-modal__modal-content-text'>
                        {modToDelete.firstName} {modToDelete.lastName}
                    </p>
                    <p className='delete-modal__modal-content-text'>
                        FROM THE {tableName} TABLE?
                    </p>
                </div>
                <div className='delete-modal__modal-buttons'>
                    <button onClick={() => setDeleteModal(false)} className='delete-modal__modal-buttons-clear'>
                        Cancel
                    </button>
                    <button onClick={() => handleDelete(modToDelete._id)} className='delete-modal__modal-buttons-colorful'>
                        Delete
                    </button>
                </div>
            </article>
        </section>
    )
}

export default DeleteModal;